import { Form, Input } from 'antd';

import { InputTplType } from '../types/tplTypes';

export const InputTpl = ({
  className,
  data,
}: {
  className?: string;
  data: InputTplType;
}) => {
  return (
    <Form.Item
      className={className}
      name={data.id}
      label={data.label}
      {...(data.formItemProps || {})}
    >
      <Input
        placeholder={data?.placeholder}
        disabled={data?.disabled}
        {...(data.componentProps || {})}
      />
    </Form.Item>
  );
};
